import arrayMove from "array-move";
import update from "immutability-helper";

export function moveChecklistItemReduce({ action, state }) {
  try {
    const { oldIndex, newIndex } = action.payload;
    return update(state, {
      openChecklist: {
        undoneIds: {
          $set: arrayMove(state.openChecklist.undoneIds, oldIndex, newIndex),
        },
      },
    });
  } catch (error) {
    console.log(error);
  }
}

export function toggleChecklistItemReduce({ action, state }) {
  let newState;
  const { done, id, name, index } = action.payload;
  const itemChanges = { done, id, name };
  if (done) {
    newState = update(state, {
      status: { $set: "pending" },
      openChecklist: {
        entities: { [id]: { $merge: itemChanges } },
        undoneIds: { $splice: [[index, 1]] },
        doneIds: {
          $apply: (dids) => {
            return [id, ...dids];
          },
        },
      },
    });
  } else {
    newState = update(state, {
      status: { $set: "pending" },
      openChecklist: {
        entities: { [id]: { $merge: itemChanges } },
        doneIds: { $splice: [[index, 1]] },
        undoneIds: {
          $apply: (dids) => {
            return [...dids, id];
          },
        },
      },
    });
  }
  console.log("newState in tcir: ", state, newState, action.payload);
  return newState;
}
